var links = document.links
for (let i = 0, linksLength = links.length; i < linksLength; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank'
    links[i].relList.add('noreferrer', 'noopener')
  }
}

$(document).ready(function () {
  if ($(window).width() > 749) {
    var offset = 1000
    var duration = 300

    $(window).scroll(function () {
      if ($(this).scrollTop() > offset) {
        $('.back-to-top').fadeIn(duration)
      } else {
        $('.back-to-top').fadeOut(duration)
      }
    })
    $('.back-to-top')
      .unbind('click.smoothscroll')
      .bind('click', function (e) {
        e.preventDefault()
        $('html, body').animate({ scrollTop: 0 }, duration)
        return false
      })
  }

  // Newsletter sign-up form already subscribed error message
  if (window.location.href.indexOf('contact%5Btags%5D=newsletter&form_type=customer') > -1) {
    $('.old-subscriber').addClass('old-subscriber-true')
  } else {
    $('.old-subscriber').removeClass('old-subscriber-true')
  }
})

if ($('.shogun-root').length === 0) {
  $('.product-single__description ').show()
}

// Prepare Blog Article images for Fancybox

// Shopify RTE
$('.rte > div > img').parent().addClass('rte-image')
$('body.template-product .rte > div > img').parent().addClass('fancybox')
$('div[style="text-align: left;"]').addClass('rte-image-left')
$('div[style="text-align: right;"]').addClass('rte-image-right')
$('div[style="text-align: center;"]').addClass('rte-image-center')
$('div[style="text-align: justify;"]').addClass('rte-image-wide')

$('.rte .rte-image + blockquote').each(function () {
  $(this).prev('.rte-image').append(this)
})

// Shogun RTE
$('body.template-product .shg-rich-text img').wrap('<a class="rte-image fancybox"></a>')
$('body.template-article .shg-rich-text img').wrap('<div class="rte-image"></div>')
$('.shg-rich-text img[style="float: left;"]').parent().addClass('rte-image-left')
$('.shg-rich-text img[style="float: right;"]').parent().addClass('rte-image-right')
$('.shg-rich-text img[style="display: block; margin-left: auto; margin-right: auto;"]')
  .parent()
  .addClass('rte-image-center')

$('.shg-rich-text pre').each(function () {
  $(this).prev('p').find('.rte-image').append(this)
})

$('body.template-article .article__list-image').each(function () {
  var mainimg_alt = $(this).attr('alt')
  if (mainimg_alt) {
    $(this).after($('<figcaption/>').append(mainimg_alt))
  }
})

$('body.template-article .shg-rich-text img').each(function () {
  var img_alt = $(this).attr('alt')
  if (img_alt) {
    $(this)
      .parent()
      .attr('data-caption', function () {
        return img_alt
      })
    $(this).after($('<figcaption/>').append(img_alt))
  }
})

$('body.template-article .article__list-image-container figcaption').each(function () {
  $(this).html($(this).text().replace(/©.*$/, '<span class="attribution">$&</span>'))
})

$('body.template-article .shg-rich-text figcaption').each(function () {
  $(this).html($(this).text().replace(/©.*$/, '<span class="attribution">$&</span>'))
})

$.fn.changeElementType = function (newType) {
  var newElements, attrs, newElement

  this.each(function () {
    attrs = {}

    $.each(this.attributes, function () {
      attrs[this.nodeName] = this.nodeValue
    })

    newElement = $('<' + newType + '/>', attrs).append($(this).contents())

    $(this).replaceWith(newElement)

    if (!newElements) {
      newElements = newElement
    } else {
      $.merge(newElements, newElement)
    }
  })

  return $(newElements)
}

$('body.template-product .rte-image').changeElementType('a')
$('.rte-image blockquote').changeElementType('figcaption')
$('.shg-rich-text pre').changeElementType('p').addClass('footnote')

$('.rte-image.fancybox').attr('href', function () {
  return $(this).children('img').attr('src')
})

// Replace Shogun lightbox with Fancybox

$('.shogun-image-lightbox-content').addClass('fancybox').removeClass('shogun-image-lightbox-content')
$('.shogun-image-container.fancybox').changeElementType('a')
$('.shogun-image-container.fancybox').attr('href', function () {
  return $(this).children('img').attr('data-src')
})
$('.shogun-image-container.fancybox').removeAttr('data-shg-lightbox-switch')
$('.shogun-image-container.fancybox img').removeAttr('data-shg-lightbox-image')
$('.rte-image img').removeAttr('style')

$('li.http_link a').attr('target', '_blank')

// Navbar collapse on hover
// This is for the main menu on desktop devices
var width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
var nav = document.querySelector('#SiteNav')
var navPar = document.querySelector('#AccessibleNav')
var navMob = document.querySelector('#SiteNavButton')
var navMobPar = document.querySelector('#MobileNavWrapper')
var navDrops = document.querySelectorAll('.site-nav--has-dropdown')

function navCollapse() {
  if (width > 749) {
    if (nav.scrollWidth > nav.offsetWidth) {
      navPar.style.opacity = '0'
      navPar.style.setProperty('pointer-events', 'none')
      navPar.style.display = 'none'
      navMob.style.display = 'inline-block'
      navMobPar.style.setProperty('display', 'block', 'important')
    } else {
      navPar.style.removeProperty('opacity')
      navPar.style.removeProperty('pointer-events')
      navMob.style.removeProperty('display')
      navMobPar.style.removeProperty('display')
    }
  }
  ;[].forEach.call(navDrops, function (el) {
    el.classList.remove('disabled')
  })
}
window.onload = navCollapse
window.onresize = navCollapse

// Announcement bar body padding for home page
const bodyEl = document.getElementsByClassName('template-index')[0]
const isHome = document.getElementsByClassName('template-index').length > 0
const isAnnouncing = document.getElementsByClassName('announcement-bar').length > 0
const headerEl = document.getElementById('shopify-section-header')
const headerHeight = headerEl.clientHeight

if (isHome && isAnnouncing) {
  bodyEl.style.paddingTop = headerHeight + 'px'
}

// Omnishop redirect banner
const delayInMilliseconds = 1500 // 1.5 seconds

setTimeout(function () {
  const redirectBanner = document.getElementById('banner-geofilter')
  const redirectBannerOn = redirectBanner.classList.contains('is-active')
  const redirectBannerHeight = document.getElementById('banner-geofilter').clientHeight
  const totalHeaderHeight = +headerHeight + +redirectBannerHeight
  if (isHome && redirectBannerOn) {
    console.log('Redirect banner is open')
    headerEl.style.paddingTop = redirectBannerHeight + 'px'
    bodyEl.style.paddingTop = totalHeaderHeight + 'px'
  } else if (redirectBannerOn) {
    headerEl.style.paddingTop = redirectBannerHeight + 'px'
  }
  var redirectBannerClose = document.getElementsByClassName('js-geofilter-optout')[1]
  redirectBannerClose.addEventListener(
    'click',
    function (e) {
      if (isHome) {
        headerEl.style.paddingTop = '0'
        bodyEl.style.paddingTop = headerHeight + 'px'
      } else {
        headerEl.style.paddingTop = '0'
      }
      console.log('Opt out')
    },
    false
  )
}, delayInMilliseconds)

// Localization form
class LocalizationForm extends HTMLElement {
  constructor() {
    super()
    this.elements = {
      input: this.querySelector('input[name="language_code"], input[name="country_code"]'),
      button: this.querySelector('button'),
      panel: this.querySelector('ul')
    }
    this.elements.button.addEventListener('click', this.openSelector.bind(this))
    this.elements.button.addEventListener('focusout', this.closeSelector.bind(this))
    this.addEventListener('keyup', this.onContainerKeyUp.bind(this))

    this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)))
  }

  hidePanel() {
    this.elements.button.setAttribute('aria-expanded', 'false')
    this.elements.panel.setAttribute('hidden', true)
  }

  onContainerKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return

    this.hidePanel()
    this.elements.button.focus()
  }

  onItemClick(event) {
    event.preventDefault()
    const form = this.querySelector('form')
    this.elements.input.value = event.currentTarget.dataset.value
    if (form) form.submit()
  }

  openSelector() {
    this.elements.button.focus()
    this.elements.panel.toggleAttribute('hidden')
    this.elements.button.setAttribute(
      'aria-expanded',
      (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
    )
  }

  closeSelector(event) {
    const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON'
    if (event.relatedTarget === null || shouldClose) {
      this.hidePanel()
    }
  }
}

customElements.define('localization-form', LocalizationForm)

$('html').attr('currency', function () {
  return $('#CurrencySelector').attr('value')
})
